export default __webpack_public_path__ + "static/media/fad-caret-down.1e293b60.svg";